import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { ProgressBar } from 'react-bootstrap';
import * as docketActions from '../../../redux/actions/docketActions';
import { hasValidClientCode } from '../../../redux/actions/clientCodeAction';
import AllPartsPrintPreview from './popups/AllPartsPrintPreview';
import EmailCombinedPdfPopup from './popups/EmailCombinedPdfPopup';
import DownloadZipAllPdfsRangePopup from './popups/DownloadZipAllPdfsRangePopup';
import DownloadCombineAllPdfInRangePopup from './popups/DownloadCombineAllPdfInRangePopup';
import DownloadZipWithSubpartsPopup from './popups/DownloadZipWithSubpartsPopup';
import PrintAllPdfInRangePopup from './popups/PrintAllPdfInRangePopup';
import EmailPartPopup from './popups/EmailPartPopup';
import EmailPartModal from './popups/EmailPartModal/EmailPartModal';
import EmailAllPartsZipPopup from './popups/EmailAllPartsZipPopup';
import DocketPacerSearchBar from './DocketPacerSearchBar';
import DocketFilters from './DocketFilters';
import DocketsPaginator from './DocketsPaginator';
import DocketError from './DocketError';
import DocketsTable from './DocketsTable';
import Notification from '../../common/Notification/Notification';
import './Docket.less';

require('classlist-polyfill');
require('react-datepicker/dist/react-datepicker.css');

const initState = {
  docNumFrom: null,
  docNumTo: null,
  date_filed_from: null,
  date_filed_to: null,
  pacerSearch: {
    date_from: null,
    date_to: null,
    doc_from: null,
    doc_to: null,
  },
  doc_range: '',
  search_keyword: '',
  sort_column: 'date_filed',
  sort_order: window.Drupal.settings.docket_sort_order || 'desc',
  docket_sort_order: window.Drupal.settings.docket_sort_order,
  collapseHeader: !(window.Drupal.settings.auto_show_docket_header === 'yes'),
};

export class Dockets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initState,
      selectedPageNum: 1,
      showPacerSearchBar: true,
      showPastEntries: false,
    };
  }

  componentDidMount() {
    if (this.props.purchase_right_away) {
      this.purchaseData();
    } else {
      const { sort_order } = this.state;
      this.getDockets({ sort_order });
    }
  }

  componentDidUpdate(prevProps) {
    // quick stop gap.  need to fix this somewhere else, probably service layer
    window.fixHeaderAssociatedCasesButton();
    window.$("#docket-header-content a[href^='/cgi-bin']").hide();

    // if there's data when the page first loads, don't show the pacer search bar
    if (prevProps.header.status !== 'done' && this.props.header.status === 'done') {
      this.setState({ showPacerSearchBar: false });
    }
  }

  getDockets = (itemParams = {}) => {
    const { case_uuid, court_code, case_number } = this.props;

    const params = {
      ...itemParams,
      case_uuid,
      court_code,
      case_number,
      sort_order: this.state.sort_order,
      sort_column: this.state.sort_column,
      page_number: this.state.selectedPageNum,
    };

    this.props.getDockets(params);
  };

  purchaseData = () =>
    this.props
      .purchaseDockets({
        case_number: this.props.case_number,
        court_code: this.props.court_code,
      })
      .then(receipt => {
        this.getDockets({ receipt });
      });

  changeDate = (type, date) => {
    this.setState({ [type]: date });
  };

  changePacerDate = (type, date) => {
    const pacerSearch = { ...this.state.pacerSearch, [type]: date };
    this.setState({ pacerSearch });
  };

  handleDateChangeRaw = (type, e) => {
    const date = e.target.value;
    if (date.split('/').length !== 3) {
      return;
    }

    const sanitized = date.split('/').reduce((accum, next, idx) => {
      const n = next.length < 2 ? `0${next}` : next;

      return idx === 0 ? accum + n : `${accum}/${n}`;
    }, '');

    const d = moment(sanitized, 'MM-DD-YYYY');

    this.setState({ [type]: d });
  };

  handlePacerDateChangeRaw = (type, e) => {
    const date = e.target.value;
    if (date.split('/').length !== 3) {
      return;
    }

    const sanitized = date.split('/').reduce((accum, next, idx) => {
      const n = next.length < 2 ? `0${next}` : next;

      return idx === 0 ? accum + n : `${accum}/${n}`;
    }, '');

    const d = moment(sanitized, 'MM-DD-YYYY');

    const pacerSearch = { ...this.state.pacerSearch, [type]: d };

    this.setState({ pacerSearch });
  };

  clear = () => {
    this.setState(initState);
  };

  clearPacerSearchFilter = () => {
    this.setState({
      pacerSearch: {
        date_from: null,
        date_to: null,
        doc_from: null,
        doc_to: null,
      },
    });
  }

  buyDocketSheet = () => {
    if (this.props.hasValidClientCode()) {
      const { pacerSearch } = this.state;
      const { date_from, date_to, doc_from, doc_to } = pacerSearch;
      let showFullDocketData = {};

      const pacerSearchFilterParams = {
        court_code: this.props.court_code,
        case_number: this.props.case_number,
        include_documents: 0,
        date_from: date_from ? date_from.format('MM/DD/YYYY') : null,
        date_to: date_to ? date_to.format('MM/DD/YYYY') : null,
        doc_from: doc_from ? parseInt(doc_from, 10) : null,
        doc_to: doc_to ? parseInt(doc_to, 10) : null,
        minimize_header: 0,
      };

      const getDocRange = () => {
        if (doc_from && doc_to) {
          return `${doc_from}-${doc_to}`;
        }
        if (doc_from) {
          return `${doc_from}-`;
        }
        if (doc_to) {
          return `-${doc_to}`;
        }
        return null;
      };

      if (window.Drupal.settings.always_show_full_docket_after_update === '') {
        showFullDocketData = {
          date_filed_from: date_from,
          date_filed_to: date_to,
          doc_range: getDocRange(),
        };
      }

      this.setState({ showPastEntries: false, ...showFullDocketData }, () => {
        this.props.purchaseDockets(pacerSearchFilterParams).then((receipt) => {
          if (window.Drupal.settings.always_show_full_docket_after_update === '') {
            const { date_filed_from, date_filed_to, doc_range } = this.state;

            const docketFilterParams = {
              date_filed_from: date_filed_from ? date_filed_from.format('MM/DD/YYYY') : null,
              date_filed_to: date_filed_to ? date_filed_to.format('MM/DD/YYYY') : null,
              docket_number_range: _.isEmpty(doc_range) ? null : doc_range,
            };

            this.getDockets({ receipt, ...docketFilterParams });
            this.clearPacerSearchFilter();
          } else {
            this.getDockets({ receipt });
            this.clear();
          }
        });
      });
    }
  };

  buyMissingDockets = docNumRange => {
    if (this.props.hasValidClientCode()) {
      const date_from = docNumRange.prev_date_filed;
      const date_to = docNumRange.next_date_filed;

      const params = {
        case_uuid: this.props.case_uuid,
        court_code: this.props.court_code,
        case_number: this.props.case_number,
        doc_from: null,
        doc_to: null,
        date_from,
        date_to,
      };

      this.props.purchaseDockets(params).then(receipt => {
        this.getDockets({ receipt });
      });
    }
  };

  getFilteredDockets = () => {
    const { court_code, case_number } = this.props;
    const { date_filed_from, date_filed_to, doc_range, search_keyword } = this.state;

    const params = {
      date_filed_from: date_filed_from ? date_filed_from.format('MM/DD/YYYY') : null,
      date_filed_to: date_filed_to ? date_filed_to.format('MM/DD/YYYY') : null,
      docket_number_range: _.isEmpty(doc_range) ? null : doc_range,
      search_keyword: _.isEmpty(search_keyword) ? null : search_keyword,
      court_code,
      case_number,
      sort_order: this.state.sort_order,
      page_number: this.state.selectedPageNum,
    };

    return this.props.getDockets(params);
  };

  onClear = () => {
    const { date_filed_from, date_filed_to, doc_range, search_keyword, pacerSearch } = initState;
    const state = {
      date_filed_from,
      date_filed_to,
      doc_range,
      search_keyword,
      pacerSearch,
    };

    this.setState(state, () => {
      this.getFilteredDockets();
    });
  };

  onGetDocuments = (docket, court_code, case_number) => {
    this.props.onGetDocuments({
      docket_no: docket.docket_no,
      docket_seq: docket.docket_seq,
      court_code,
      case_number,
    });
  };

  popupForm = {
    EmailCombinedPdfPopup,
    AllPartsPrintPreview,
    DownloadZipAllPdfsRangePopup,
    DownloadZipWithSubpartsPopup,
    DownloadCombineAllPdfInRangePopup,
    PrintAllPdfInRangePopup,
    EmailPartPopup,
    EmailPartModal,
    EmailAllPartsZipPopup,
  };

  changePage = (headerParams, itemParams) => {
    // todo old was in setstate, make sure this is working
    // page: itemParams.page
    this.setState({ selectedPageNum: itemParams.page_index }, () => {
      this.getDockets(itemParams);
    });
  };

  sortDockets = sort_column => {
    const sort_order = this.state.sort_order === 'asc' ? 'desc' : 'asc';

    this.setState({ sort_column, sort_order }, this.getDockets);
  };

  toggleHeader = () => {
    this.setState({ collapseHeader: !this.state.collapseHeader });
  };

  pastEntriesClick = () => {
    if (this.props.hasValidClientCode()) {
      this.setState({ showPacerSearchBar: true, showPastEntries: true });
    }
  };

  pastEntriesHide = () => {
    this.setState({ showPacerSearchBar: false, showPastEntries: false });
    this.clear();
  };

  updateClick = () => {
    if (this.props.hasValidClientCode()) {
      let { date_from } = this.state.pacerSearch;
      const { sort_order, sort_column, collapseHeader } = this.state;
      const {
        header: { latest_known_date_filed },
      } = this.props;

      if (_.isEmpty(date_from) && !_.isEmpty(this.props.dockets.entries)) {
        const sorted = _.sortBy(this.props.dockets.entries.data, entry =>
          moment(entry.date_filed, 'MM/DD/YYYY')
        ).reverse();
        date_from = moment(sorted[0].date_filed, 'MM/DD/YYYY');
      }

      const pacerSearch = {
        ...this.state.pacerSearch,
        date_from: date_from || moment(latest_known_date_filed, 'MM/DD/YYYY'),
      };
      const state = {
        ...initState,
        pacerSearch,
        showPacerSearchBar: true,
        sort_order,
        sort_column,
        collapseHeader,
      };

      this.setState(state, () => {
        this.buyDocketSheet();
      });
    }
  };

  showRedactPopup = seqNum => {
    this.props.updateRedact({ showPopup: true, seqNum });
  };

  closeRedactPopup = () => {
    this.props.updateRedact({ showPopup: false });
  };

  redact = () => {
    this.closeRedactPopup();

    const { seqNum } = this.props.redact;
    const num = parseFloat(seqNum);
    const doc_range = num % 1 === 0 ? num.toString() : '';

    const { case_uuid } = this.props;

    const params = {
      redactSeqNum: seqNum,
      doc_range,
      case_uuid,
      sort_order: this.state.sort_order,
      page_number: this.state.selectedPageNum,
      court_code: this.props.court_code,
      case_number: this.props.case_number,
      // sort_field:
    };

    this.setState({ doc_range }, () => {
      this.props.deleteAndRepurchase(params).then(() => {
        this.props.updateRedact({ seqNum: null });
      });
    });
  };

  // TODO: check func usage
  reloadDetails = () => {
    const { selectedDocket, court_code, case_number } = this.props;
    this.getFilteredDockets().then(() => this.onGetDocuments(selectedDocket, court_code, case_number));
  };

  changeFilter = (e, name) => {
    const filter = { [name]: e.target.value };
    this.setState(filter, () => {
      this.props.filterDocketEntries(filter);
    });
  };

  changePacerFilter = (e, name) => {
    const pacerSearch = { ...this.state.pacerSearch, [name]: e.target.value };
    this.setState({ pacerSearch });
  };

  allFiltersEmpty = () => {
    const filtersAreEmpty =
      _.isEmpty(this.state.search_keyword) &&
      _.isEmpty(this.state.doc_range) &&
      _.isEmpty(this.state.date_filed_from) &&
      _.isEmpty(this.state.date_filed_to);

    const pacerFiltersAreEmpty =
      _.isEmpty(this.state.pacerSearch.date_from) &&
      _.isEmpty(this.state.pacerSearch.date_to) &&
      _.isEmpty(this.state.pacerSearch.doc_from) &&
      _.isEmpty(this.state.pacerSearch.doc_to);

    return filtersAreEmpty && pacerFiltersAreEmpty;
  };

  render() {
    const { header, entries, selectedDocket } = this.props;
    const lastUpdated = header.modified || '';

    let { showMissingDockets } = entries;
    showMissingDockets = showMissingDockets && this.allFiltersEmpty();

    const docketFilterProps = {
      keyword: this.state.search_keyword,
      doc_range: this.state.doc_range,
      date_filed_from: this.state.date_filed_from,
      date_filed_to: this.state.date_filed_to,
      onChange: this.changeFilter,
      changeDate: this.changeDate,
      onChangeDateRaw: this.handleDateChangeRaw,
      getFilteredDockets: this.getFilteredDockets,
      onClear: this.onClear,
    };

    const docketSearchBarProps = {
      showPastEntries: this.state.showPastEntries,
      pastEntriesHide: this.pastEntriesHide,
      changePacerFilter: this.changePacerFilter,
      changePacerDate: this.changePacerDate,
      handlePacerDateChangeRaw: this.handlePacerDateChangeRaw,
      pacerSearch: this.state.pacerSearch,
      buyDocketSheet: this.buyDocketSheet,
      clearPacerSearchFilter: this.clearPacerSearchFilter,
    };

    const docketEntriesProps = {
      filterTable: () => null,
      entries,
      lastUpdated,
      showMissingDockets,
      selectedDocket,
      redact: this.props.redact,
      buyMissingDockets: this.buyMissingDockets,
      onGetDocuments: this.onGetDocuments,
      showRedactPopup: this.showRedactPopup,
      case_uuid: this.props.case_uuid,
      court_code: this.props.court_code,
      case_number: this.props.case_number,
      sortDockets: this.sortDockets,
      updateClick: this.updateClick,
      pastEntriesClick: this.pastEntriesClick,
      latest_known_date_filed: header.latest_known_date_filed || '',
      reloadDetails: this.reloadDetails,
      keyword: this.state.search_keyword,
    };

    const visibleDocketNums = _.get(entries, 'data', []).reduce((accum, next) => {
      // use docket_no to determine that it's not a missing entry type of docket
      if (next.isVisible && next.docket_no) {
        accum.push(next.docket_seq);
      }
      return accum;
    }, []);

    const docketsPaginatorProps = {
      total_pages: _.get(entries, 'total_pages', 0),
      visibleDocketNums,
      case_uuid: this.props.case_uuid,
      court_code: this.props.court_code,
      case_number: this.props.case_number,
      selectedPageNum: this.state.selectedPageNum,
      changePage: this.changePage,
      onPopupClick: this.props.onPopupClick,
      toggleHeader: this.toggleHeader,
      getDocketParts: this.props.getDocketParts,
      updateDocketParts: this.props.updateDocketParts,
    };

    const { name } = this.props.popup;
    const DocketsPopupComponentType = this.props.popup.show && this.popupForm[name];

    const showPacerSearchBarClassName = this.state.showPacerSearchBar ? 'show-pacer-search-bar' : '';

    const docketsTableProps = {
      showPacerSearchBar: this.state.showPacerSearchBar,
      DocketsPopupComponentType,
      docketSearchBarProps,
      docketFilterProps,
      docketEntriesProps,
      showMissingDockets,
      header,
      docketsPaginatorProps,
      lastUpdated,
      error: this.props.error,
      receipt: this.props.receipt,
      popup: this.props.popup,
      showPacerSearchBarClassName,
      collapseHeader: this.state.collapseHeader,
      showRedactPopup: this.props.redact.showPopup,
      closeRedactPopup: this.closeRedactPopup,
      redact: this.redact,
      reloadDetails: this.reloadDetails,
      onPopupClick: this.props.onPopupClick,
    };

    return (
      <div className="docket">
        <Notification />
        {this.state.showPacerSearchBar && <DocketPacerSearchBar {...docketSearchBarProps} />}
        {header.status && (
          <div className={showPacerSearchBarClassName}>
            <DocketFilters {...docketFilterProps} caseUuid={docketEntriesProps.case_uuid} />
            <DocketsPaginator {...docketsPaginatorProps} hasToolbar />
          </div>
        )}
        {header.status === 'loading' && (
          <div>
            {this.state.showPacerSearchBar && <div>Contacting PACER...</div>}
            <div>
              <ProgressBar active now={100} />
            </div>
          </div>
        )}
        <DocketError errors={this.props.error} />
        {/* existence of header is used to detect if table rows should be shown */}
        {header.status === 'done' && <DocketsTable {...docketsTableProps} />}
      </div>
    );
  }
}

Dockets.defaultProps = {
  purchase_right_away: false,
  error: null,
  receipt: null,
  lastUpdated: null,
};

Dockets.propTypes = {
  case_uuid: PropTypes.any.isRequired,
  purchase_right_away: PropTypes.bool,
  dataReady: PropTypes.bool.isRequired,
  dockets: PropTypes.object.isRequired,
  docketParts: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  header: PropTypes.object.isRequired,
  redact: PropTypes.object.isRequired,
  selectedDocket: PropTypes.object.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any,
  error: PropTypes.any,
  court_code: PropTypes.string.isRequired,
  case_number: PropTypes.string.isRequired,
  entries: PropTypes.object.isRequired,
  onGetDocuments: PropTypes.func.isRequired,
  getDockets: PropTypes.func.isRequired,
  purchaseDockets: PropTypes.func.isRequired,
  resetDocketParts: PropTypes.func.isRequired,
  onPopupClick: PropTypes.func.isRequired,
  hasValidClientCode: PropTypes.func.isRequired,
  updateRedact: PropTypes.func.isRequired,
  deleteAndRepurchase: PropTypes.func.isRequired,
  filterDocketEntries: PropTypes.func.isRequired,
  updateDocketParts: PropTypes.func.isRequired,
  getDocketParts: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const irSearch = state.get('irSearch').toJS();
  const dockets = irSearch.data.reduce((accum, next) => {
    // eslint-disable-next-line
    accum[next[0]] = next[1];
    return accum;
  }, {});

  const { popup, docketParts, header, redact, selectedDocket, entries, receipt } = state.get('dockets').toJS();

  return {
    dataReady: irSearch.data_ready,
    dockets,
    entries,
    receipt,
    lastUpdated: irSearch.lastUpdated,
    error: irSearch.error,
    popup,
    docketParts,
    header,
    redact,
    selectedDocket,
  };
};

const mapDispatchToProps = {
  onGetDocuments: docketActions.getDocuments,
  resetDocketParts: docketActions.resetDocketParts,
  onPopupClick: docketActions.togglePopup,
  getDockets: docketActions.getDockets,
  purchaseDockets: docketActions.purchaseDockets,
  hasValidClientCode,
  updateRedact: docketActions.updateRedact,
  deleteAndRepurchase: docketActions.deleteAndRepurchase,
  filterDocketEntries: docketActions.filterDocketEntries,
  updateDocketParts: docketActions.updateDocketParts,
  getDocketParts: docketActions.getDocketParts,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dockets);



// WEBPACK FOOTER //
// ./src/components/case/docket/Dockets.jsx